export default "__VITE_PUBLIC_ASSET__fedbfdfa__"